module.exports = __webpack_public_path__ + "static/media/dodgem(21).8425ef75.PNG";